import { 
    GET_EMPLOYEES_DATA,
    FETCH_DROPDOWN_DATAS,
    STATUS_UPDATE,
    GENERATE_ONBOARDING_LINK,
    DEPARTMENT_DROPDOWN,
    TEAM_DROPDOWN,
    ROLE_DROPDOWN,
    REPORTING_MANAGER_DROPDOWN,
    CITIES_DROPDOWN,
    ZONES_DROPDOWN,
    AREAS_DROPDOWN,
    ASSIGN_LOCATION,
    ASSIGN_REPORTEE,
    USER_LOCATION_MAPPING,
    USER_TEAM_MAPPING,
    DELETE_USER_MAPPING
} from "./type";

const initalState = {
    getEmployeesListing: [],
    getDropdownDatas: [],
    statusUpdationByBusinessHead: [],
    onboardingLinkForEmployee: [],
    departmentDropwdownResponse: [],
    teamDropdownResponse: [],
    roleDropdownResponse: [],
    reportingManagerResponse: [],
    citiesDropdownResponse: [],
    zonesDropdownResponse: [],
    areasDropdownResponse: [],
    assignLocationResponse: [],
    assignReportingToResponse: [],
    getLocationMappingByUserIdResponse: [],
    getTeamMappingByUserIdResponse: [],
    deleteUserMappingResponse: []
};

const offroleEmployeesReducer = (state = initalState, action) => {
    const { type, payload } = action;
    switch (type) {
        case GET_EMPLOYEES_DATA:
            return {
                ...state,
                getEmployeesListing: payload
            };
        case FETCH_DROPDOWN_DATAS:
            return {
                ...state,
                getDropdownDatas: payload
            };
        case STATUS_UPDATE:
            return {
                ...state,
                statusUpdationByBusinessHead: payload
            };
        case GENERATE_ONBOARDING_LINK:
            return {
                ...state,
                onboardingLinkForEmployee: payload
            };
        case DEPARTMENT_DROPDOWN:
            return {
                ...state,
                departmentDropwdownResponse: payload
            };
        case TEAM_DROPDOWN:
            return {
                ...state,
                teamDropdownResponse: payload
            };
        case ROLE_DROPDOWN:
            return {
                ...state,
                roleDropdownResponse: payload
            };
        case REPORTING_MANAGER_DROPDOWN:
            return {
                ...state,
                reportingManagerResponse: payload
            };
        case CITIES_DROPDOWN:
            return {
                ...state,
                citiesDropdownResponse: payload
            };
        case ZONES_DROPDOWN:
            return {
                ...state,
                zonesDropdownResponse: payload
            };
        case AREAS_DROPDOWN:
            return {
                ...state,
                areasDropdownResponse: payload
            };
        case ASSIGN_LOCATION:
            return {
                ...state,
                assignLocationResponse: payload
            };
        case ASSIGN_REPORTEE:
            return {
                ...state,
                assignReportingToResponse: payload
            };
        case USER_LOCATION_MAPPING:
            return {
                ...state,
                getLocationMappingByUserIdResponse: payload
            };
        case USER_TEAM_MAPPING:
            return {
                ...state,
                getTeamMappingByUserIdResponse: payload
            };
        case DELETE_USER_MAPPING:
            return {
                ...state,
                deleteUserMappingResponse: payload
            };
        default:
            return {
                ...state,
            };
    }
};

export default offroleEmployeesReducer;
